// @flow
import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import Layout from '../components/layout';
import PageMeta from '../components/PageMeta';

import rnfirebaseLogo from '../assets/images/rnfirebase-logo.svg';
import mybabybioLogo from '../assets/images/mybabybio-logo.png';

export default () => (
  <Layout>
    <PageMeta title="Products | CS Frequency" />
    <section className="module-page-title">
      <div className="container">
        <div className="row-page-title">
          <div className="page-title-captions">
            <h1 className="h3">Products</h1>
          </div>
          <div className="page-title-secondary">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <GatsbyLink to="/">Home</GatsbyLink>
              </li>
              <li className="breadcrumb-item active">Products</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <section className="module module-divider-bottom">
      <div className="container">
        <div className="row m-b-100">
          <div className="col-md-12">
            <div className="special-heading">
              <h3>Commercial</h3>
            </div>
          </div>
          <div className="col-md-2 text-center">
            <a href="https://mybabybio.com">
              <img className="product-logo" src={mybabybioLogo} />
            </a>
          </div>
          <div className="col-md-10">
            <div className="icon-box">
              <div className="icon-box-title">
                <h6>
                  <a href="https://mybabybio.com">MyBabyBio</a>
                </h6>
              </div>
              <div className="icon-box-content">
                <p>
                  MyBabyBio launched in 2017 as a privacy-focused mobile
                  application for iOS and Android. It allows parents to record
                  and share memories of their children privately and securely.
                </p>
                <p>
                  Making use of React Native, Firebase and Google Cloud
                  Platform, the app gives us a showcase for the development work
                  we can do, as well as ensuring that we're keeping up to date
                  with some of the technology that we offer to our clients.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);
